import { del, get, post } from '@/api/request.ts';

export interface Response {
  chapterName: string;
  correctCount?: number;
  errorCount: number;
  firstErrorAt: string;
  questionContent: string;
  questionId: number;
  questionType?: string;
  subjectName: string;
  subjectId?: number;
  username: string;
}

export interface DeleteResponse {
  deleted: boolean;
  questionId: number;
  [property: string]: any;
}

async function fetchWrongbookApi(username: string) {
  const result = await get<any>('/assessment/wrong-book/analytics/', { username });
  const items = Array.isArray(result.data) ? result.data : (result.data?.data ?? result.data);
  if (!Array.isArray(items))
    return items;

  return items.map(item => ({
    ...item,
    correctCount: Number(item.correctCount ?? item.correct_count ?? 0),
    errorCount: Number(item.errorCount ?? item.error_count ?? 0),
  }));
}

async function deleteWrongbookQuestionApi(questionId: number) {
  const candidates: Array<() => Promise<any>> = [
    () => del<DeleteResponse | { data?: DeleteResponse }>('/assessment/wrong-book/', { questionId }),
    () => del<DeleteResponse | { data?: DeleteResponse }>(`/assessment/wrong-book/?questionId=${questionId}`),
    () => del<DeleteResponse | { data?: DeleteResponse }>(`/assessment/wrong-book/${questionId}/`),
  ];

  let lastError: unknown = null;
  for (const request of candidates) {
    try {
      const result = await request();
      return (result as any)?.data ?? result;
    }
    catch (e) {
      lastError = e;
    }
  }

  throw lastError;
}

async function addSubjectiveWrongbookApi(questionId: string) {
  return (await post<{ questionId: string; isInWrongbook: boolean }>('/assessment/wrong-book/add/', { questionId })).data;
}

export { addSubjectiveWrongbookApi, deleteWrongbookQuestionApi, fetchWrongbookApi };
